import { useState } from "react"
import PropTypes from "prop-types"
import { ExpandLess, ExpandMore, InfoOutlined } from "@mui/icons-material"
import { Box, IconButton, Typography } from "@mui/material"
import classNames from "classnames"
import ExternalLinks from "components/link"
import { useAnalytics } from "connected-components/analytics"
import Markdown from "markdown-to-jsx"
import { AI_TEAMMATE_EVENTS } from "../../../analytics"

export default function ExplainSteps({ explainSteps }) {
  const analytics = useAnalytics()
  const [isExpanded, setIsExpanded] = useState(false)

  function handleToggle() {
    if (!isExpanded) {
      analytics.track(AI_TEAMMATE_EVENTS.TABLE_EXPLAIN_OPENED)
    }
    setIsExpanded(!isExpanded)
  }

  return <Box className={classNames("table-artifact-explain-steps", { expanded: isExpanded })}>
    <Box className="explain-steps-trigger" onClick={handleToggle}>
      <Box className="explain-steps-trigger-content">
        <InfoOutlined fontSize="small" />
        How was this table generated?
      </Box>
      <IconButton size="small" className="explain-steps-trigger-expand-icon" disableRipple>
        {isExpanded ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
    </Box>

    <Box className="explain-steps-content">
      <Typography variant="subtitle2">
        Table Generation Steps
      </Typography>
      <Box className="explain-steps">
        <ExternalLinks>
          <Markdown className="explain-steps-markdown">{explainSteps}</Markdown>
        </ExternalLinks>
      </Box>
    </Box>
  </Box>
}

ExplainSteps.propTypes = {
  explainSteps: PropTypes.string.isRequired,
}
